import { render, staticRenderFns } from "./contact-details-item.vue?vue&type=template&id=3256702c&scoped=true&"
import script from "./contact-details-item.vue?vue&type=script&lang=js&"
export * from "./contact-details-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3256702c",
  null
  
)

export default component.exports